import { useEffect, useState } from "react";
import { CheckIcon, Combobox, Group, Pill, PillsInput, useCombobox } from "@mantine/core";

export function CreatableMultiSelect({
  data,
  value,
  onChange,
  label,
  placeholder,
  dscription,
  onCreate,
  className,
  onPaste,
  ...props
}) {
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
    onDropdownOpen: () => combobox.updateSelectedOptionIndex("active"),
  });

  const [search, setSearch] = useState("");
  const [dataLocal, setDataLocal] = useState(data);
  const [valueLocal, setValueLocal] = useState([]);

  const exactOptionMatch = dataLocal.some((item) => item === search);

  const handleValueSelect = (val) => {
    setSearch("");

    if (val === "$create") {
      setDataLocal((current) => [...current, search]);
      setValueLocal((current) => [...current, search]);
      onCreate(search);
    } else {
      setValueLocal((current) => (current.includes(val) ? current.filter((v) => v !== val) : [...current, val]));
    }
  };

  const handleValueRemove = (val) => setValueLocal((current) => current.filter((v) => v !== val));

  const values = valueLocal.map((item) => (
    <Pill key={item} withRemoveButton onRemove={() => handleValueRemove(item)}>
      {item}
    </Pill>
  ));

  const options = dataLocal
    .filter((item) => item.toLowerCase().includes(search.trim().toLowerCase()))
    .map((item) => (
      <Combobox.Option value={item} key={item} active={valueLocal.includes(item)}>
        <Group gap="sm">
          {value.includes(item) ? <CheckIcon size={12} /> : null}
          <span>{item}</span>
        </Group>
      </Combobox.Option>
    ));

  useEffect(() => {
    if (onChange) {
      onChange(valueLocal);
    }
  }, [valueLocal]);

  useEffect(() => {
    if (value) {
      setValueLocal(value);
    }
  }, [value]);

  return (
    <Combobox store={combobox} onOptionSubmit={handleValueSelect} withinPortal={false}>
      <Combobox.DropdownTarget>
        <PillsInput
          label={label}
          placeholder={placeholder}
          description={dscription}
          className={className}
          onPaste={(paste) => {
            if (onPaste) {
              onPaste(paste);
            }
          }}
          onClick={() => combobox.openDropdown()}>
          <Pill.Group>
            {values}

            <Combobox.EventsTarget>
              <PillsInput.Field
                onFocus={() => combobox.openDropdown()}
                onBlur={() => combobox.closeDropdown()}
                value={search}
                placeholder={placeholder ? placeholder : "Hledej..."}
                onChange={(event) => {
                  combobox.updateSelectedOptionIndex();
                  setSearch(event.currentTarget.value);
                }}
                onKeyDown={(event) => {
                  if (event.key === "Backspace" && search.length === 0) {
                    event.preventDefault();
                    handleValueRemove(valueLocal[valueLocal.length - 1]);
                  }
                }}
              />
            </Combobox.EventsTarget>
          </Pill.Group>
        </PillsInput>
      </Combobox.DropdownTarget>

      <Combobox.Dropdown>
        <Combobox.Options>
          {options}

          {!exactOptionMatch && search.trim().length > 0 && (
            <Combobox.Option value="$create">+ Create {search}</Combobox.Option>
          )}

          {exactOptionMatch && search.trim().length > 0 && options.length === 0 && (
            <Combobox.Empty>Nothing found</Combobox.Empty>
          )}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
}
